export default function registerComLiveChat($, apower) {
  $.register("com-live-chat", {
    template: `<div class="com-live-chat" @click="openLiveChat">
        <span class="chat-dot"><i></i><i></i><i></i></span><span><slot></slot></span>
		</div>`,
    props: ["width", "height", "bottom", "right", "img", "chaturl"],
    width: 80,
    height: 80,
    bottom: 17,
    right: 17,
    chaturl: "",
    img: "",
    iframeEl: "",
    tryChatTimerId: -1,
    onReady() {
      this.addCss();
      this.el.css("bottom", this.bottom + "px");
      this.el.css("right", this.right + "px");
      this.el.css("overflow", "hidden");
      this.el.css("display", "none");
      this.initLiveChat();
      this.tryCheckLiveChatStat();
    },
    addCss() {
      var css = document.createElement("style");
      css.type = "text/css";
      css.innerHTML = `#chat-widget-container iframe#chat-widget-minimized{display: none !important;}`;
      document.head.appendChild(css);
    },
    showEl() {
      this.el.css("display", "block");
    },
    initLiveChat() {
      var script = document.createElement("script");
      script.innerHTML = `window.__lc = window.__lc || {};
      window.__lc.license = 13031466;
      ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))`;
      var noscript = document.createElement("noscript");
      noscript.innerHTML = `<a href="https://www.livechatinc.com/chat-with/13031466/" rel="nofollow">Chat with us</a>, powered by <a href="https://www.livechatinc.com/?welcome" rel="noopener nofollow" target="_blank">LiveChat</a>`;
      document.body.appendChild(script);
      document.body.appendChild(noscript);
    },
    tryCheckLiveChatStat() {
      this.tryChatTimerId = setInterval(() => {
        this.checkLiveChatState();
      }, 400);
    },
    stopCheckLiveChatStat() {
      clearInterval(this.tryChatTimerId);
      this.tryChatTimerId = -1;
    },
    checkLiveChatState() {
      if (window["LiveChatWidget"] && window["LiveChatWidget"].get) {
        this.stopCheckLiveChatStat();
        this.initLiveChatEvent();
      }
    },
    initLiveChatEvent() {
      window["LiveChatWidget"].on("ready", (data) => {
        this.showEl();
      });
    },
    openLiveChat() {
      if (window["LiveChatWidget"] && window["LiveChatWidget"].get) {
        window["LiveChatWidget"].call("maximize");
      }
    },
    onClick() {},
  });
}
